/*
 * 文件类型
 *
 * @Author:    1024创新实验室-主任：卓大
 * @Date:      2022-09-03 22:09:10
 * @Wechat:    zhuda1024
 * @Email:     lab1024@163.com
 * @Copyright  1024创新实验室 ( https://1024lab.net )，Since 2012
 */
// 文件上传类型
export const FILE_FOLDER_TYPE_ENUM = {
  COMMON: {
    value: 1,
    desc: '通用',
  },
  NOTICE: {
    value: 2,
    desc: '公告',
  },
  HELP_DOC: {
    value: 3,
    desc: '帮助中心',
  },
  FEEDBACK: {
    value: 4,
    desc: '意见反馈',
  },
  REPORTTEMPLATE: {
    value: 5,
    desc: '报告模板',
  },
  CACIMAGE: {
    value: 6,
    desc: 'CAC图片',
  },
  SOP: {
    value: 7,
    desc: 'SOP文件',
  },
  SIGN: {
    value: 8,
    desc: '签名文件',
  },
  FORMFILE: {
    value: 9,
    desc: '报表文件',
  }
};
export default {
  FILE_FOLDER_TYPE_ENUM,
};
